import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import constants from '../../../../constants';
import IssuanceUniversityCardInfoView from './IssuanceUniversityCardInfoView';
import { Creators as procedureActions } from '../../../../../../../domain/useCases/procedures/getProcedureInformation';
import routes from '../../../../../../components/Routes/routingMap';
import useExternalSettings from '@/presentation/hooks/useExternalSettings';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';

const IssuanceUniversityCardInfoViewController = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const params: any = useParams();

  const [showModalFotoConfirmation, setShowModalFotoConfirmation] =
    useState(false);
  const [showModalInRequest, setShowModalInRequest] = useState(false);
  const [showModalNotAvailable, setShowModalNotAvailable] = useState(false);
  const [showModalCurrentPeriod, setShowModalCurrentPeriod] = useState(false);
  const [showModalProcessFinished, setShowModalProcessFinished] =
    useState(false);

  const {
    procedure: procedureSelectedInfo,
    selectedProcedureId,
    isLoading
  } = useSelector((state: any) => state.procedureInformation);

  const { procedureWhiteList } = useExternalSettings();

  React.useEffect(() => {
    GoogleAnalytics.writeLog(`portal-procedure-issuanceUniversity`, 'portal');
    if (!procedureSelectedInfo && !isLoading) {
      const selectedRequest: any =
        constants.categories.requests.procedureList.find(
          (p: any) => p.url === params.changeCareerCampusModality
        );
      dispatch(
        procedureActions.getProcedureInformation(
          selectedRequest?.procedureId ||
            constants.categories.requests.procedures.issuanceUniversityCard
        )
      );
    }
  }, []);

  const selectedRequest = constants.categories.requests.procedureList.find(
    (p: any) => p.procedureId === selectedProcedureId
  );

  const handleBack = () => history.goBack();
  const handleRedirectRegisterPhoto = () =>
    history.push('/tramites/autogestionables/registro-foto');

  const handleCloseModalFoto = () => {
    setShowModalFotoConfirmation(false);
  };

  const handleCloseModalInRequest = () => {
    setShowModalInRequest(false);
  };

  const handleCloseModalNotAvailable = () => {
    setShowModalNotAvailable(false);
  };

  const handleCloseModalCurrentPeriod = () => {
    setShowModalCurrentPeriod(false);
  };

  const handleCloseModalProcessFinished = () => {
    setShowModalProcessFinished(false);
  };

  const handlerRequest = () => {
    if (procedureSelectedInfo?.disabled) {
      setShowModalNotAvailable(true);
    } else if (!procedureSelectedInfo?.hasPhoto) {
      setShowModalFotoConfirmation(true);
    } else if (!procedureSelectedInfo?.isValidatedStudentFoto) {
      setShowModalFotoConfirmation(true);
    } else if (procedureSelectedInfo?.isprocessFinished) {
      setShowModalProcessFinished(true);
    } else if (procedureSelectedInfo?.requestInProgress) {
      setShowModalInRequest(true);
    } else if (!procedureSelectedInfo?.enrollment) {
      setShowModalCurrentPeriod(true);
    } else {
      history.push(
        routes.student.procedures.categories.requests.issuancefuniversitycard
          .procedureregister
      );
    }
  };

  const handleExistRequest = () => {
    history.push('/tramites');
  };

  if (
    selectedProcedureId !== undefined &&
    procedureWhiteList?.length > 0 &&
    !procedureWhiteList?.includes(selectedProcedureId?.toString())
  ) {
    history.push(routes.student.procedures.home);
  }

  return (
    <IssuanceUniversityCardInfoView
      procedureSelectedInfo={procedureSelectedInfo}
      selectedRequest={selectedRequest}
      handleCloseModalFoto={handleCloseModalFoto}
      showModalFotoConfirmation={showModalFotoConfirmation}
      showModalInRequest={showModalInRequest}
      showModalNotAvailable={showModalNotAvailable}
      showModalCurrentPeriod={showModalCurrentPeriod}
      showModalProcessFinished={showModalProcessFinished}
      handlerRequest={handlerRequest}
      handleExistRequest={handleExistRequest}
      handleBack={handleBack}
      handleCloseModalInRequest={handleCloseModalInRequest}
      handleRedirectRegisterPhoto={handleRedirectRegisterPhoto}
      handleCloseModalNotAvailable={handleCloseModalNotAvailable}
      handleCloseModalCurrentPeriod={handleCloseModalCurrentPeriod}
      handleCloseModalProcessFinished={handleCloseModalProcessFinished}
    />
  );
};

export default IssuanceUniversityCardInfoViewController;
